<div
  *ngIf="display$() | async"
  class="fixed inset-0 z-20 w-full profile-menu sm:top-2 sm:inset-auto sm:absolute sm:w-max bg-body-light dark:bg-body-dark sm:bg-box-light sm:dark:bg-box-dark sm:rounded-2xl"
>
  <ul class="p-4">
    <li class="border-b sm:border-none border-input dark:border-black-light">
      <a
        (click)="toggleDisplay(false)"
        [routerLink]="['/profile/update']"
        routerLinkActive="router-link-active"
        class="flex items-center text-left h-14 dark:text-white"
      >
        <span class="flex items-center content-center w-full m-auto ml-2">
          <span class="flex items-center justify-start w-8 h-8 text-2xl">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                class="fill-current dark:black"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.9999 0.500244C7.24443 0.509279 2.94294 3.32566 1.03303 7.68077C-0.87687 12.0359 -0.0348119 17.1079 3.1799 20.6122C5.45169 23.0748 8.64952 24.4754 11.9999 24.4754C15.3503 24.4754 18.5481 23.0748 20.8199 20.6122C24.0346 17.1079 24.8767 12.0359 22.9668 7.68077C21.0569 3.32566 16.7554 0.509279 11.9999 0.500244ZM11.9999 22.1004C9.51406 22.0966 7.1266 21.1287 5.3399 19.4004C6.44934 16.6995 9.08007 14.9361 11.9999 14.9361C14.9197 14.9361 17.5505 16.6995 18.6599 19.4004C16.8732 21.1287 14.4857 22.0966 11.9999 22.1004ZM9.59992 10.1002C9.59992 8.77476 10.6744 7.70024 11.9999 7.70024C13.3254 7.70024 14.3999 8.77476 14.3999 10.1002C14.3999 11.4257 13.3254 12.5002 11.9999 12.5002C10.6744 12.5002 9.59992 11.4257 9.59992 10.1002ZM20.2919 17.3005C19.2198 15.4666 17.5696 14.0402 15.5999 13.2445C17.3018 11.3148 17.1794 8.38636 15.3224 6.60537C13.4654 4.82439 10.5344 4.82439 8.67744 6.60537C6.82045 8.38636 6.69805 11.3148 8.39992 13.2445C6.43024 14.0402 4.78008 15.4666 3.70792 17.3005C2.85345 15.8451 2.40198 14.1883 2.39992 12.5005C2.39992 7.1986 6.69798 2.90054 11.9999 2.90054C17.3018 2.90054 21.5999 7.1986 21.5999 12.5005C21.5979 14.1883 21.1464 15.8451 20.2919 17.3005Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="w-full mt-0 ml-2 text-base capitalize">{{
            'profile.myProfile' | translate
          }}</span>
        </span>
      </a>
    </li>
    <li
      class="block pt-3 border-b sm:hidden sm:pt-0 sm:border-none border-input dark:border-black-light"
    >
      <a
        (click)="toggleDisplay(false)"
        [routerLink]="['/refer-a-friend']"
        routerLinkActive="router-link-active"
        class="flex items-center text-left h-14 dark:text-white"
      >
        <span class="flex items-center content-center w-full m-auto ml-2">
          <span class="flex items-center justify-start w-8 h-8 text-2xl">
            <svg
              width="23"
              height="23"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20 7.86997C19.871 7.49628 19.5339 7.23368 19.14 7.19997L13.45 6.36997L10.9 1.19997C10.7329 0.854984 10.3833 0.635864 10 0.635864C9.61668 0.635864 9.26709 0.854984 9.1 1.19997L6.55 6.35997L0.860003 7.19997C0.482426 7.25364 0.168247 7.5174 0.0500032 7.87997C-0.0581124 8.23389 0.0380594 8.61858 0.300003 8.87997L4.43 12.88L3.43 18.56C3.34753 18.9449 3.49852 19.3423 3.81573 19.5754C4.13294 19.8084 4.55736 19.8337 4.9 19.64L10 16.97L15.1 19.64C15.2404 19.7192 15.3989 19.7605 15.56 19.76C15.7718 19.7607 15.9784 19.6942 16.15 19.57C16.4668 19.343 16.6229 18.9528 16.55 18.57L15.55 12.89L19.68 8.88997C19.9747 8.6403 20.0993 8.24324 20 7.86997ZM13.85 11.87C13.6151 12.0982 13.5067 12.4269 13.56 12.75L14.28 16.95L10.52 14.95C10.2238 14.8035 9.87619 14.8035 9.57999 14.95L5.81999 16.95L6.53999 12.75C6.59325 12.4269 6.48492 12.0982 6.24999 11.87L3.24999 8.87L7.45999 8.26C7.78894 8.21424 8.0737 8.00816 8.21999 7.71L9.99999 3.9L11.88 7.72C12.0263 8.01816 12.311 8.22425 12.64 8.27L16.85 8.88L13.85 11.87Z"
                fill="#fff"
                class="fill-current dark:black"
              />
            </svg>
          </span>
          <span class="w-full mt-0 ml-2 text-base">{{
            'nav.refer' | translate
          }}</span>
        </span>
      </a>
    </li>
    <li
      class="pt-3 border-b sm:pt-0 sm:border-none border-input dark:border-black-light"
    >
      <a
        (click)="toggleDisplay(false)"
        [routerLink]="['/settings/general']"
        routerLinkActive="router-link-active"
        tabindex="0"
        class="flex items-center text-left h-14 focus:ring-2 dark:text-white"
      >
        <span class="flex items-center content-center w-full m-auto ml-2">
          <span class="flex items-center justify-start w-8 h-8 text-2xl">
            <svg
              width="24"
              height="23"
              viewBox="0 0 24 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.563 8.72317L20.421 8.00917L21.4297 5.99184C21.6392 5.5591 21.5529 5.04123 21.2143 4.69984L18.8003 2.28584C18.457 1.94212 17.9327 1.8555 17.497 2.07051L15.4797 3.07917L14.7657 0.937174C14.6111 0.479492 14.1834 0.170095 13.7003 0.166508H10.3003C9.81309 0.16525 9.37958 0.475554 9.22366 0.937174L8.50966 3.07917L6.49233 2.07051C6.05959 1.86096 5.54172 1.94727 5.20033 2.28584L2.78633 4.69984C2.44261 5.04322 2.35599 5.56748 2.571 6.00317L3.57966 8.02051L1.43766 8.73451C0.97998 8.88908 0.670584 9.31677 0.666996 9.79984V13.1998C0.665738 13.6871 0.976043 14.1206 1.43766 14.2765L3.57966 14.9905L2.571 17.0078C2.36145 17.4406 2.44776 17.9585 2.78633 18.2998L5.20033 20.7138C5.54371 21.0576 6.06797 21.1442 6.50366 20.9292L8.521 19.9205L9.23499 22.0625C9.39091 22.5241 9.82442 22.8344 10.3117 22.8332H13.7117C14.1989 22.8344 14.6324 22.5241 14.7883 22.0625L15.5023 19.9205L17.5197 20.9292C17.9494 21.1333 18.461 21.0473 18.8003 20.7138L21.2143 18.2998C21.5581 17.9565 21.6447 17.4322 21.4297 16.9965L20.421 14.9792L22.563 14.2652C23.0207 14.1106 23.3301 13.6829 23.3337 13.1998V9.79984C23.3349 9.3126 23.0246 8.87909 22.563 8.72317ZM21.067 12.3837L19.707 12.837C19.074 13.0424 18.5632 13.5154 18.3101 14.1308C18.057 14.7462 18.087 15.4418 18.3923 16.033L19.0383 17.325L17.7916 18.5717L16.5336 17.8917C15.9456 17.5987 15.2593 17.5753 14.6527 17.8276C14.046 18.0798 13.5786 18.5828 13.3716 19.2064L12.9183 20.5664H11.1163L10.663 19.2064C10.4577 18.5734 9.98458 18.0626 9.36919 17.8095C8.75379 17.5564 8.05824 17.5864 7.46698 17.8917L6.17498 18.5377L4.92831 17.291L5.60831 16.033C5.9136 15.4418 5.94366 14.7462 5.69052 14.1308C5.43738 13.5154 4.92661 13.0424 4.29364 12.837L2.93364 12.3837V10.6157L4.29364 10.1624C4.92661 9.95706 5.43738 9.48398 5.69052 8.86858C5.94366 8.25319 5.9136 7.55764 5.60831 6.96638L4.96231 5.70838L6.20898 4.46171L7.46698 5.10771C8.05824 5.413 8.75379 5.44306 9.36919 5.18992C9.98458 4.93678 10.4577 4.42601 10.663 3.79304L11.1163 2.43304H12.8843L13.3376 3.79304C13.543 4.42601 14.016 4.93678 14.6314 5.18992C15.2468 5.44306 15.9424 5.413 16.5336 5.10771L17.8256 4.46171L19.0723 5.70838L18.3923 6.96638C18.0993 7.55444 18.0759 8.24069 18.3282 8.84735C18.5804 9.45401 19.0834 9.92138 19.707 10.1284L21.067 10.5817V12.3837ZM12.0003 6.96652C9.49662 6.96652 7.46698 8.99616 7.46698 11.4998C7.46698 14.0035 9.49662 16.0332 12.0003 16.0332C14.504 16.0332 16.5336 14.0035 16.5336 11.4998C16.5336 10.2975 16.056 9.14446 15.2059 8.2943C14.3557 7.44413 13.2026 6.96652 12.0003 6.96652ZM12.0003 13.7664C10.7485 13.7664 9.73364 12.7516 9.73364 11.4997C9.73364 10.2479 10.7485 9.23304 12.0003 9.23304C13.2522 9.23304 14.267 10.2479 14.267 11.4997C14.267 12.7516 13.2522 13.7664 12.0003 13.7664Z"
                fill="white"
                class="fill-current dark:black"
              />
            </svg>
          </span>
          <span class="w-full mt-0 ml-2 text-base capitalize">{{
            'settings.settingTitle' | translate
          }}</span>
        </span>
      </a>
    </li>

    <li class="pt-3 sm:pt-0">
      <button
        (click)="toggleDarkMode()"
        class="flex items-center w-full text-left h-14 dark:text-white"
      >
        <span class="flex items-center content-center w-full m-auto ml-2">
          <span class="flex items-center justify-start w-8 h-8 text-2xl">
            <svg
              width="24"
              height="23"
              viewBox="0 0 24 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                class="fill-current dark:black"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.9254 12.6334C22.5916 12.3575 22.1298 12.2959 21.7354 12.4747C20.537 13.0231 19.234 13.3054 17.916 13.3021C12.8412 13.2959 8.72183 9.19676 8.6907 4.12205C8.69587 3.35799 8.79097 2.5972 8.97403 1.85538C9.05313 1.45278 8.90846 1.03886 8.59577 0.773199C8.28309 0.507536 7.85124 0.43162 7.4667 0.574717C2.56697 2.77789 -0.15256 8.08169 0.918114 13.3462C1.98879 18.6107 6.56393 22.4309 11.935 22.5453C17.306 22.6596 22.0396 19.0376 23.3334 13.8234C23.4502 13.3807 23.2892 12.9112 22.9254 12.6334ZM12.1587 20.2153C8.26151 20.1878 4.802 17.7143 3.51555 14.0354C2.22909 10.3565 3.39324 6.26613 6.42404 3.81599V4.12199C6.43029 10.4663 11.5718 15.6077 17.916 15.614C18.716 15.6169 19.514 15.5333 20.296 15.3647C18.7021 18.3801 15.5695 20.2649 12.1587 20.2607V20.2153Z"
                fill="white"
              />
            </svg>
          </span>
          <span class="flex-1 mt-0 ml-2 text-base capitalize dark:text-white">{{
            'settings.darkMode' | translate
          }}</span>
          <span class="flex items-center cursor-pointer">
            <span class="mr-2 text-sm text-gray">
              {{
                ((isDarkModeSelected$() | async)
                  ? 'settings.on'
                  : 'settings.off'
                ) | translate
              }}
            </span>
            <div class="relative">
              <div class="toggle" id="toggleContainer">
                <!-- line -->
                <div
                  class="w-12 h-8 rounded-full shadow-inner bg-gray dark:bg-blue-500"
                ></div>
                <!-- dot -->
                <div
                  class="absolute bg-white rounded-full shadow h-7 toggle-slider w-7"
                  [ngClass]="{
                    '-checked': isDarkModeSelected$() | async
                  }"
                ></div>
              </div>
            </div>
          </span>
        </span>
      </button>
    </li>
  </ul>
</div>
